import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import NicheCallouts from "@/components/site/NicheCallouts";
import About from "@/components/site/About";
import Credentials from "@/components/site/Credentials";
import HowItWorks from "@/components/site/HowItWorks";
import Programs from "@/components/site/Programs";
import AddOns from "@/components/site/AddOns";
import Everfit from "@/components/site/Everfit";
// Testimonials block moved to dedicated /testimonial page (Feb 2026)
import Compare from "@/components/site/Compare";
import Discounts from "@/components/site/Discounts";
import Social from "@/components/site/Social";
import LeadMagnet from "@/components/site/LeadMagnet";
import FieldNotes from "@/components/site/FieldNotes";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Reveal from "@/components/site/Reveal";
import ExitIntent from "@/components/site/ExitIntent";
import SpotifySplash from "@/components/site/SpotifySplash"; // eslint-disable-line no-unused-vars -- kept for future re-enable
import LegacySplash from "@/components/site/LegacySplash";
import LiveCounter from "@/components/site/LiveCounter";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#0A0A0A] text-white font-body overflow-x-hidden">
      <Nav />
      <Hero />
      <Marquee />
      <LiveCounter />
      <NicheCallouts />
      <Reveal><About /></Reveal>
      <Reveal><Credentials /></Reveal>
      <Reveal><HowItWorks /></Reveal>
      <Reveal><Programs /></Reveal>
      <Reveal><AddOns /></Reveal>
      <Reveal><Compare /></Reveal>
      <Reveal><Everfit /></Reveal>
      <Reveal><LeadMagnet /></Reveal>
      <Reveal><Discounts /></Reveal>
      <Reveal><Social /></Reveal>
      <Reveal><FieldNotes /></Reveal>
      <Reveal><FAQ /></Reveal>
      <Reveal><Contact /></Reveal>
      <Footer />
      <ExitIntent />
      <LegacySplash />
      {/* <SpotifySplash /> — temporarily disabled per user request. Re-enable by uncommenting. */}
    </main>
  );
}
